import { useQuery } from '@tanstack/react-query'
import { fetchApiWithToken } from '../utils'

export type MessageSendingInfo = {
  service: string
  smsMax: number
  smsRemaining: number
  smsRemainingType: string
  stopSMSLength: number
  singleSMSLength: number
  multiSMSLength: number
  forbiddenChars: string
  replaceChars: string
}

type MessageSendingInfoParams = {
  agencyId?: number | null
  enabled?: boolean
}

export const useMessageSendingInfo = ({
  agencyId,
  enabled
}: MessageSendingInfoParams) =>
  useQuery<MessageSendingInfo, Error>({
    queryKey: ['messageSendingInfo', agencyId],
    queryFn: ({ signal }) =>
      fetchApiWithToken<MessageSendingInfo>({
        method: 'get',
        signal,
        url: `/v1/configuration/message_sending_info${agencyId ? `?agencyId=${agencyId}` : ''}`
      }),
    staleTime: 1000 * 60 * 5, // 5 minutes
    enabled: enabled ?? true
  })
